import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
const DrugPayIndent = (props) => {
    const {did} = useParams();
    const [patientData, setPatientData] = useState([]);
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-');
    const [opbillData, setopbillData] = useState([]);
    const [lres, setLres] = useState([]);
    const [lnet, setLnet] = useState([]);
    const [rows, setRows] = useState([]);
    const [viewPharmData, setViewPharmData] = useState([]);
    const [viewIndentData, setViewIndentData] = useState([]);
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [subtotal, setSubTotal] = useState(0);
    const [changed, setChanged] = useState(false);
    const [pharmData, setpharmData] = useState({
        "sale_id": '',
        "sale_type": '',
        "pat": '',
        "patient": '',
        "cons": '',
        "product": '',
        "qty": '',
        "netamount": '',
        "total": '',
        "disc": '',
        "details": '',
        "paid": '',
        "balance": '',
        "mode": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        if (did) {
            axios.get(`${baseUrl}view-indent-drug/${did}/`)
                .then(response => {
                    const data = response.data;
                    setopbillData([data]);
                    setLres(data.qty.split(','));
                })
                .catch(error => console.log(error));
        }
    }, [did]);
    useEffect(() => {
        if (opbillData.length > 0) {
            fetchPharmData();
        }
    }, [opbillData]);
    const fetchPharmData = () => {
        const productIds = opbillData[0].product.split(',').map(item => item.trim());
        const indentRequests = productIds.map(id =>
            axios.get(`${baseUrl}update-indent-use/${id}/`)
                .then(response => response.data)
                .catch(error => console.log(error))
        );
        Promise.all(indentRequests)
            .then(indentData => {
                setViewIndentData(indentData);
                // Flatten the product array and map to IDs
                const pharmIds = indentData.map(data => data.product.toString().trim());
                const pharmRequests = pharmIds.map(id =>
                    axios.get(`${baseUrl}update-pharm-qty/${id}/`)
                        .then(response => response.data)
                        .catch(error => console.log(error))
                );
                return Promise.all(pharmRequests);
            })
            .then(pharmData => {
                setViewPharmData(pharmData);
            })
            .catch(error => console.log(error));
    };
    useEffect(() => {
        setRows(viewPharmData);
    }, [viewPharmData]);
    const handleChange = (e, subIndex) => {
        const {name, value} = e.target;
        setpharmData(prevState => ({...prevState, [name]: value}));
    };
    const formSubmit = (e) => {
        e.preventDefault();
        const dept = document.getElementById("dept").value;
        const user = document.getElementById("user").value;
        const dbType = document.getElementById("dbType").value;
        const details = document.getElementById("details").value;
        // Prepare product IDs, quantities, and net amounts
        const productInputs = Array.from(document.querySelectorAll('[id^="id-"]'));
        const productIds = productInputs.map(input => input.value.trim()).filter(id => id);
        const quantities = lres.map(qty => parseFloat(qty) || 0);
        const netAmounts = lnet.flat();
        // Prepare data for API requests
        const formData = new FormData();
        axios.post(`${baseUrl}get_sale_pharm/`)
            .then(response => {
                const saleId = response.data.value;
                formData.append('sale_id', saleId);
                formData.append('sale_type', 'IndentBill');
                formData.append('patient', dept);
                formData.append('product', productIds.join(','));
                formData.append('qty', quantities.join(','));
                formData.append('netamount', netAmounts.join(','));
                formData.append('total', total.toFixed(2));
                formData.append('mode', dbType);
                formData.append('details', details);
                formData.append('status', '1');
                formData.append('addedby', userName);
                formData.append('ip_add', ipAddress);
                formData.append('location', userLocation);
                return axios.post(`${baseUrl}pharm-sale-other/`, formData)
                    .then(() => {
                        const updateIndentRequests = productIds.map((id, index) => {
                            const matchingIndentData = viewIndentData.find(data => data.product == id);
                            const originalQty = quantities[index];
                            if (matchingIndentData) {
                                return axios.post(`${baseUrl}update-indent-use-add/`, {
                                    id: matchingIndentData.id,
                                    user: user,
                                    product: id,
                                    dept: dept,
                                    qty: originalQty,
                                    ip_add: ipAddress,
                                    addedby: userName,
                                    location: userLocation,
                                });
                            }
                        });
                        return Promise.all(updateIndentRequests).then(() => saleId);
                    })
                    .then(saleId => {
                        const saleIdInt = parseInt(saleId, 10);
                        return axios.put(`${baseUrl}view-indent-drug/${did}/`, {
                            status: 2,
                            sale_id: saleIdInt,
                            ip_add: ipAddress,
                        });
                    })
                    .then(() => {
                        Swal.fire({
                            title: 'Pharmacy Bill Generated.',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        setTimeout(() => {
                            window.location.href = `/pharm-invoice-indent/${saleId}`;
                        }, 2000);
                    })
                    .catch(error => {
                        console.log(error);
                        Swal.fire('Error!', 'Failed to process the form. Please try again later.', 'error');
                    });
            })
            .catch(error => {
                console.log(error);
                Swal.fire('Error!', 'Failed to retrieve sale ID. Please try again later.', 'error');
            });
    };
    const calculateLnet = (opbillData, viewPharmData, lres) => {
        return opbillData.map((row, index) => {
            return row.product.split(',').map((test, subIndex) => {
                const indentData = viewIndentData.find((data) => data.id == parseInt(test));
                let pharmData;
                if (indentData) {
                    const prod = indentData.product;
                    pharmData = viewPharmData.find((data) => data.id == parseInt(prod));
                }
                const qty = parseFloat(lres[subIndex] || indentData?.qty || 0);
                const uamount = parseFloat(pharmData?.uamount || 0);
                return qty * uamount; // Calculate netamount here
            });
        });
    };
    useEffect(() => {
        if (opbillData.length > 0 && viewPharmData.length > 0) {
            const newLnet = calculateLnet(opbillData, viewPharmData, lres);
            setLnet(newLnet);
        }
    }, [opbillData, viewPharmData, lres]);
    useEffect(() => {
        let subTotal = 0;
        let newTotal = 0;
        if (viewPharmData.length > 0) {
            subTotal = arraySum(lnet);
            if (rows.length > 0) {
                let subTotal1 = 0;
                for (let i = 0; i < rows.length; i++) {
                    const row = rows[i];
                    subTotal1 += parseFloat(row.uamount);
                }
                subTotal += subTotal1;
            }
            newTotal = subTotal;
            setSubTotal(subTotal);
            setTotal(newTotal);
        }
    }, [lnet, rows, viewPharmData]);
    const arraySum = (arr) => {
        const flattenedArr = arr.flat();
        return flattenedArr.reduce((total, value) => {
            const numericValue = parseFloat(value) || 0; // Handle empty strings and non-numeric values
            return total + numericValue;
        }, 0);
    };
    return (
        <section className="container mt-4">
            <form>
                <div className="row table-responsive">
                    <div className='col-md-12 col-12 mb-2'>
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Department</th>
                                <th>Department User</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td style={{width: '10%'}}><input className="form-control" type="text" name="dept"
                                                                  id="dept" value={opbillData.map(row => row.dept)}
                                                                  readOnly/></td>
                                <td style={{width: '20%'}}><input className="form-control" type="text" name="user"
                                                                  id="user" value={opbillData.map(row => row.user)}
                                                                  readOnly/></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='table-responsive'>
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th style={{width: 60}}>ID</th>
                            <th style={{width: 170}}>Drug Name</th>
                            <th style={{width: 50}}>Qty</th>
                            <th style={{width: 110}}>Batch</th>
                            <th style={{width: 90}}>Expiry</th>
                            <th style={{width: 50}}>Qty in Stock</th>
                            <th style={{width: 110}}>MRP 1s</th>
                            <th style={{width: 110}}>Net Amount</th>

                        </tr>
                        </thead>

                        <tbody>
                        {opbillData.map((row, index) => {
                            return row.product.split(',').map((test, subIndex) => {
                                const indentData = viewIndentData.find((data) => data.id == parseInt(test));
                                let pharmData; // Declare pharmData outside the if block
                                if (indentData) {
                                    const prod = indentData.product;
                                    pharmData = viewPharmData.find((data) => data.id == parseInt(prod));
                                }
                                const uniqueKey = `${index}-${subIndex}`;
                                const qty = parseFloat(lres[subIndex] || indentData?.qty || 0); // Use lres if available, then indentData.qty, otherwise default to 0
                                const uamount = parseFloat(pharmData?.uamount || 0); // Use pharmData.uamount or default to 0
                                const netamount = qty * uamount;
                                return (
                                    <tr key={uniqueKey}>
                                        <td>
                                            <input
                                                type="text"
                                                name={`id-${index}`}
                                                id={`id-${index}`}
                                                value={pharmData?.id || ''}
                                                onChange={(e) => handleChange(e, index)}
                                                style={{width: 60}}
                                                tabIndex={-1}
                                                readOnly
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="product"
                                                value={pharmData?.product || ''}
                                                onChange={(e) => handleChange(e, index)}
                                                style={{width: 250}}
                                                tabIndex={-1}
                                                readOnly
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                min={0}
                                                style={{width: 90}}
                                                className="ms-4 me-2"
                                                name={`qty-${index}`}
                                                id={`qty-${index}`}
                                                value={qty} // Set initial value based on lres or indentData.qty
                                                data-uamount={uamount}
                                                data-totqty={indentData?.qty || 0} // Use indentData.qty or default to 0
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value >= 0) {
                                                        const updatedLres = lres.map((item, i) =>
                                                            i === subIndex ? e.target.value : item
                                                        );
                                                        setLres(updatedLres);
                                                    }
                                                }}
                                                tabIndex={0}
                                                required
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                style={{width: 140}}
                                                name="batch"
                                                value={pharmData?.batch || ''}
                                                onChange={(e) => handleChange(e, subIndex)}
                                                tabIndex={-1}
                                                readOnly
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="ms-4 me-2"
                                                style={{width: 90}}
                                                name="expiry"
                                                value={pharmData?.expiry || ''}
                                                onChange={(e) => handleChange(e, subIndex)}
                                                tabIndex={-1}
                                                readOnly
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="ms-4 me-2"
                                                style={{width: 90}}
                                                name={`totqty-${subIndex}`}
                                                id={`totqty-${subIndex}`}
                                                value={indentData?.qty || ''}
                                                onChange={(e) => handleChange(e, subIndex)}
                                                tabIndex={-1}
                                                readOnly
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="ms-4 me-2"
                                                style={{width: 90}}
                                                name="uamount"
                                                value={pharmData?.uamount || ''}
                                                tabIndex={-1}
                                                readOnly
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="ms-4 me-2"
                                                style={{width: 140}}
                                                name={`netamount-${index}`}
                                                id={`netamount-${index}`}
                                                value={netamount.toFixed(2)} // Set initial value based on calculated netamount
                                                tabIndex={-1}
                                                readOnly
                                            />
                                        </td>
                                    </tr>
                                );
                            });
                        })}

                        </tbody>


                    </table>

                    <div className="row ms-5 mt-5">
                        <div className="col-md-6">
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                                 className='ms-5'>
                                <div className="form-group">
                                    <label style={{fontWeight: 'bold'}}>Subtotal: &nbsp;</label>
                                    <div className="input-group">
                                        <div className="input-group-addon me-2 ">&#8377;</div>
                                        <input type="number" onChange={handleChange} value={subtotal} readOnly/>
                                    </div>
                                </div>

                                <div className="form-group mt-3">
                                    <label style={{fontWeight: 'bold'}}>Total: &nbsp;</label>
                                    <div className="input-group">
                                        <div className="input-group-addon me-2 ">&#8377;</div>
                                        <input type="number" onChange={handleChange} name="tot" value={total} readOnly/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Choose Payment Type</label>
                                <select name="dbType" id="dbType">
                                    <option value="Indent">Indent</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Details:</label>
                                <textarea
                                    className="no-comma form-control"
                                    tabIndex="0"
                                    name="details"
                                    id="details"
                                    rows={2}
                                    cols={2}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                         className='mb-5'>
                        <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
                    </div>
                </div>
            </form>
        </section>
    );
};
export default DrugPayIndent;
